import IconDescription from "../../../../components/ui/icon-description/icon-description";
import TipImg from "../../../../assets/images/tip.jpeg";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { Fade } from "react-awesome-reveal";

import "./poles-tip.scss";

const PolesTip = () => {
  const device = useBreakpoint();
  const isMobile = device === "mobile" || device === "tablet";
  return (
    <section className="poles-tip">
      {!isMobile && (
        <div className="poles-tip__img-section">
          <Fade direction="left" duration={800} triggerOnce>
            <img
              className="poles-tip__img poles-tip__img--desktop"
              src={TipImg}
              alt="Punte in acciaio"
            />
          </Fade>
        </div>
      )}
      <div
        className="poles-tip__text-section"
        style={!!isMobile ? { marginBottom: "1rem" } : {}}
      >
        <Fade direction="right" duration={800} delay={100} triggerOnce>
          <h2 className="poles-tip__title">Le Punte in Acciaio</h2>
          <div className="poles-tip__text-container">
            <p className="poles-tip__text">
              Le punte in acciaio a perdere sono progettate per penetrare nel
              terreno e ancorarsi nello strato portante più profondo.
            </p>
            <p className="poles-tip__text">
              Attraverso la testa di rotazione, la punta viene avvitata fino al
              raggiungimento dello strato individuato dall'indagine geotecnica,
              caratterizzato dai valori più elevati di qc.
            </p>
          </div>
          <Fade
            cascade
            direction="up"
            delay={200}
            duration={900}
            damping={0.15}
            triggerOnce
          >
            <div className="poles-tip__list">
              <IconDescription
                icon={"checked"}
                title={"Punte a Perdere"}
                text={"Design brevettato"}
                type={"primary"}
                size={"small"}
              />
              <IconDescription
                icon={"checked"}
                title={"Avanzamento Controllato"}
                text={"Penetrazione precisa"}
                type={"primary"}
                size={"small"}
              />
              <IconDescription
                icon={"checked"}
                title={"Ammorsamento Profondo"}
                text={"Strato portante"}
                type={"primary"}
                size={"small"}
              />
              <IconDescription
                icon={"checked"}
                title={"Controllo Geotecnico"}
                text={"Valori qc elevati"}
                type={"primary"}
                size={"small"}
              />
            </div>
          </Fade>
        </Fade>
      </div>

      {!!isMobile && (
        <Fade direction="up" duration={700} triggerOnce>
          <img
            className="poles-tip__img poles-tip__img--mobile"
            src={TipImg}
            alt="Punte in acciaio"
          />
        </Fade>
      )}
    </section>
  );
};

export default PolesTip;
